import { render, staticRenderFns } from "./Running.vue?vue&type=template&id=4420e52b&scoped=true&"
import script from "./Running.vue?vue&type=script&lang=js&"
export * from "./Running.vue?vue&type=script&lang=js&"
import style0 from "./Running.vue?vue&type=style&index=0&id=4420e52b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4420e52b",
  null
  
)

export default component.exports